export default "__VITE_ASSET__BsO$kXkJ__"